<template>
    <div class="sfbz">
        <div class="searchall">
            <div class="flc" style="margin-top:10px">
                <div class="ban">
                   <span>楼栋号：</span>
                    <select name="" id="" v-model="ldhss" class="xiala">
                        <option :value="item.id" v-for="(item,index) in ldh">{{item.title}}</option>
                    </select> 
                </div>
                <div class="ban">
                   <span>楼层：</span>
                    <select name="" id="" v-model="lcss" class="xiala">
                        <option :value="item.id" v-for="(item,index) in lc">{{item.text}}</option>
                    </select> 
                </div>
                <div class="ban">
                   <span>户室号：</span>
                    <select name="" id="" v-model="huss" class="xiala">
                        <option :value="item.id" v-for="(item,index) in hu">{{item.text}}</option>
                    </select> 
                </div>
            </div>
            <div class="search datesearch" style="margin-top:10px">
                <span>所属时间：</span>
                <input type="date" v-model="starttime">
                -
                <input type="date" v-model="endtime">
            </div>
            <div class="btns">
                <button class="searchbt" @click="chongzhi">重置</button>
                <button class="searchbt" style="margin-left:20px" @click="search">搜索</button>
            </div>
            
        </div>
        
        <div class="sfbzcontent">
            <div class="bz">
                <table class="tb" border="1" >
                    <thead>
                        <tr>
                            <th style="width:10%">序号</th>
                            <th  style="width:20%">房屋信息</th>
                            <th  style="width:10%">面积</th>
                            <th  style="width:10%">是否缴纳物业费</th>
                            <th  style="width:10%">应缴</th>
                            <th  style="width:10%">实缴</th>
                            <th style="width:10%">缴费区间</th>
                            <th  style="width:20%">备注</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in wyflist">
                            <td style="width:10%">{{item.id}}</td>
                            <td style="width:20%">{{item.houseMsg}}</td>
                            <td style="width:10%">{{item.houseArea}}</td>
                            <td style="width:16%">{{item.isPay}}</td>
                            <td style="width:12%">￥{{item.lstaccrbal || 0}}</td>
                            <td style="width:12%">￥{{item.paymentAccount || 0}}</td>
                            <td style="width:10%">{{item.jfqj}}</td>
                            <td style="width:20%">{{item.bz}}</td>
                        </tr>
                        
                    </tbody>
                </table>
                <van-pagination v-model="pageNum" @change='onLoad()' :page-count="totalPages" items-per-page="10" mode="simple"/>
            </div>
        </div>
        <div style="height:20px;width:100%"></div>
    </div>
</template>
<script>
import { ImagePreview } from 'vant';
export default {
    data() {
        return {
            pageNum:1,
            ldh:[],//楼栋号
            lc:[],//楼层
            hu:[],//户
            wyflist:[],
            ldhss:'',//楼栋号搜索
            lcss:'',//楼层搜索，
            huss:'',//户搜索
            loading: false,//列表加载的
            finished: false,//列表加载的
            refreshing: false,//列表加载的
            refreshing:false,
            ss:'',
            list:[],
            total:'',
            starttime:'',
            endtime:'',
            totalPages:'',//总页数
            isgengduo:false,
        }
    },
    watch: {
        ldhss:function(newval,oldval){
            if(newval != ''){
                this.getlc(newval)
            }
            
        },
        lcss:function(newval,oldval){
            if(newval != ''){
                this.gethu(newval)
            }
        }
    },
    mounted() {
        this.getldh()
        this.getdata(this.starttime,this.endtime,this.huss,this.lcss,this.ldhss)
    },
    methods: {
        gethu(id){
            this.$axios.get('/api/v1/wechat/select/house',{
                params:{
                    floorId:id
                }
            }).then(res=>{
                this.hu = res
            })
        },
        getlc(id){
            this.$axios.get('/api/v1/wechat/select/floor',{
                params:{
                    buildingId:id
                }
            }).then(res=>{
                this.lc = res
            })
        },
        getldh(){
            this.$axios.get('/api/v1/wechat/select/building2', {
                params: {

                }
            }).then(res => {
                this.ldh = res
            });
        },
        chongzhi(){
            this.starttime = ''
            this.endtime = ''
            this.ldhss = ''
            this.lcss = ''
            this.huss = ''
            this.pageNum = 1
            this.total = 0
            this.wyflist = []
            this.getdata(this.starttime,this.endtime,this.huss,this.lcss,this.ldhss)
        },
        search(){
            this.wyflist = []
            this.total = 0
            this.pageNum = 1
            this.getdata(this.starttime,this.endtime,this.huss,this.lcss,this.ldhss)
        },
        showimg(index){
            var that = this
            ImagePreview({
                images: that.list[index].attachs.map(item=>{
                    return item.webUrl
                }),
                closeable: true,
            });
        },
        getdata(dateStart,dateEnd,hid,fid,bid){
            this.$axios.get('/api/v1/wygl/propertyFeeDetails/viewList', {
                params: {
                    pageNum:this.pageNum-1,
                    pageSize:10,
                    startMonth:dateStart,
                    endMonth:dateEnd,
                    houseId:hid,
                    floorNo:fid,
                    buildingNo:bid,
                }
            }).then(res => {
                res.data.forEach((element,index) => {
                    if(element.isPay==1){
                        element.isPay = '是'
                    }else{
                        element.isPay = '否'
                    }
                    element.id = (this.pageNum-1)*10+(index+1)
                    var reg=new RegExp("null","g"); //创建正则RegExp对象
                    element.jfqj = element.jfqj.replace(reg,"");
                    if(element.jfqj.length > 40){
                        var date1 = element.jfqj.substring(0,10).replace(/-/g,'.')
                        var date2 = element.jfqj.substring(22,32).replace(/-/g,'.')
                        element.jfqj = date1+'-'+date2
                    }else{
                        element.jfqj = '暂无'
                    }
                });
                this.wyflist = res.data
                this.total = res.total
                this.totalPages = res.totalPages
            });
        },
        onLoad(){
            this.getdata(this.starttime,this.endtime,this.huss,this.lcss,this.ldhss)
        }
    },
}
</script>
<style lang="less" scoped>
    .xiala{
        outline: none;
        border: 1px solid #939393;
        border-radius: 5px;
        height: 30px;
        width: 50%;
    }
    /deep/ .van-pagination{
        width: 100%;
    }
    .flc{
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .jzgd{
        margin-top: 10px;
        color: #00b5ff;
    }
    .sfbz{
        .sfbzcontent{
            margin: 2% 5%;
        }
        .van-list{
            width: 100%;
        }
        .van-swipe-item{
            img{
            height: 100%;
            width: 100%;
            }
        }
        .searchall{
            width: 100%;
            padding:0 10px 10px 10px;
            display: flex;
            flex-direction: column;
            input{
                outline: none;
                border: 1px solid #939393;
                border-radius: 5px;
                height: 30px;
            }
        }
        .btns{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 10px;
        }
        .tb{
            font-size: 12px;
            text-align: center; border-color:#000; border-collapse: collapse;
            thead{
                color: #000;
                font-size: 12px;
            }
            tbody{
                width: 100%;
                tr{
                    height: 20px;
                }
            }
        }
        .searchbt{
            height: 30px;
            width: 100px;
            background: #00b5ff;
            border-radius: 10px;
            border: none;
            outline: none;
            color: #fff;
        }
        .ban{
                width: 100%;
                margin-top: 10px;
                display: flex;
                span{
                    width: 20%;
                    font-size: 13px;
                }
                select{
                    width: 50%;
                }
            }
        .search{
            display: flex;
            align-items: center;
            font-size: 13px;
            text-align: center;
            span{
                width: 20%;
            }
            
        }
        .datesearch{
            input{
                width: 34%;
            }
        }
        .bz{
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            border-radius: 10px;
            box-shadow: 0 0 10px #dadada;
            padding: 10px;
            box-sizing: border-box;
            .fyitem {
                margin-top: 10px;
                height: 100px;
                width: 100%;
                display: flex;
                .lb {
                    width: 35%;
                    height: 100%;
                }
                .fyxx {
                    margin-left: 2%;
                    font-size: 13px;
                    width: 60%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-around;
                }
            }
        }
    }
</style>